import { createFileRoute } from "@tanstack/react-router"
import { createLLMOMeta, createBreadcrumbSchema, createFAQSchema } from "@/lib/seo"
import { getUseCaseBySlug } from "@/data/use-cases/use-cases-registry"
import { getUseCaseBySlugForLanguage } from "@/data/use-cases/use-cases-i18n"
import { useTranslation } from "@/lib/i18n"
import UseCasePageLayout from "@/components/use-cases/UseCasePageLayout"

const data = getUseCaseBySlug("instagram-story-reply-automation")!

export const Route = createFileRoute("/use-case/instagram-story-reply-automation")({
  head: () => ({
    meta: [
      ...createLLMOMeta({
        title: data.seo.title,
        description: data.seo.description,
        url: "https://zapify.pro/use-case/instagram-story-reply-automation",
      }),
      { name: "keywords", content: data.seo.keywords },
    ],
    links: [{ rel: "canonical", href: "https://zapify.pro/use-case/instagram-story-reply-automation" }],
    scripts: [
      createBreadcrumbSchema({
        itemListElement: [
          { position: 1, name: "Home", item: "https://zapify.pro" },
          { position: 2, name: "Use Cases", item: "https://zapify.pro/use-case" },
          { position: 3, name: data.name, item: "https://zapify.pro/use-case/instagram-story-reply-automation" },
        ],
      }),
      createFAQSchema(data.faqs),
    ],
  }),
  component: StoryRepliesPage,
})

function StoryRepliesPage() {
  const { language } = useTranslation()
  const localizedData = getUseCaseBySlugForLanguage(language, "instagram-story-reply-automation") || data
  return <UseCasePageLayout data={localizedData} />
}
